export { ResponsiveBackgroundImage } from './ResponsiveBackgroundImage'
